import React from "react";
import { getPrettyDayMonth } from "../lib/format";
import { resultLabelClass } from "./resultLabel";

const LatestResultDetail = ({ item }) => {
  return (
    <tr>
      <td>{getPrettyDayMonth(item.match_date)}</td>
      <td>{item.opponent}</td>
      <td>{item.match_home_or_away}</td>
      <td>{item.competition}</td>
      <td>
        <span className={resultLabelClass(item.result)}>{item.match_score}</span>
      </td>
    </tr>
  );
};

export default LatestResultDetail;
